import { ICONS } from 'constants/icons';
import { useTranslation } from 'react-i18next';
import styles from './NoCarList.module.scss';

export default function NoCarList() {
  const { t } = useTranslation();

  return (
    <div className={styles.NoCarList}>
      <div className={styles.message_container}>
        <div>
          <img src={ICONS.ALERT} alt='alert' />
        </div>
        <div className={styles.message}>{t('parking.carList.noCar')}</div>
      </div>
    </div>
  );
}
